import React from "react";
import { connect } from 'react-redux';
// react component for creating dynamic tables
import ReactTable from "react-table";
import Datetime from "react-datetime";


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Close from "@material-ui/icons/Close";
import SaveAlt from "@material-ui/icons/SaveAlt";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from '@material-ui/core/TextField';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Tooltip from "@material-ui/core/Tooltip";

import Today from "@material-ui/icons/Today";


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { fetchJobCardsRequest } from "../../../actions/jobCard";
import { formatStatus, prepareJobCardReports } from "../../../utils/helpers";
import Reports from "./Reports";


const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
};

class ViewJobCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openReportDialog: false,
    }
  }

  componentWillMount() {
    this.props.dispatch(fetchJobCardsRequest());
  }

  attachActions(jobCards) {
    return jobCards.map((prop, key) => {
      return Object.assign(prop,
        {
          status: formatStatus(prop.status),
          type: formatStatus(prop.type),
          actions: (
            // we've added some custom button actions
            <div className="actions-right">
              {/* use this button to add a edit kind of action */}
              <Tooltip
                id="tooltip-top"
                title="View Job Card"
                placement="top"
              >
                <Button
                  justIcon
                  round
                  simple
                  color="warning"
                  className="edit"
                  onClick={() => this.props.history.push(`job/view/${prop.jobCardNumber}`)}
                >
                  <Dvr />
                </Button>
              </Tooltip>
              {" "}
              {/* use this button to remove the data row */}
              <Tooltip
                id="tooltip-top"
                title="Delete Job Card"
                placement="top"
              >
                <Button
                  justIcon
                  round
                  simple
                  color="danger"
                  className="remove"
                >
                  <Close />
                </Button>
              </Tooltip>
              {" "}
            </div>
          )
        });
    })
  }

  render() {
    const { classes } = this.props;

    let jobCards = this.props.jobsData.jobCards || [];
    jobCards = this.attachActions(jobCards);
    return (
      <GridContainer>
        <GridItem xs={12}>
          <GridItem>
          <center>
           
          <Reports />

          </center></GridItem>
          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>List of Job Cards</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={jobCards}
                filterable
                columns={[
                  {
                    Header: "Job Card No",
                    accessor: "jobCardNumber"
                  },
                  {
                    Header: "Created At",
                    accessor: "createdAt"
                  },
                  {
                    Header: "Job Type",
                    accessor: "type"
                  },
                  {
                    Header: "Status",
                    accessor: "status"
                  },
                  {
                    Header: "Town",
                    accessor: "stand.town"
                  },
                  {
                    Header: "Project",
                    accessor: "project.name"
                  },
                  {
                    Header: "Last Modified",
                    accessor: "lastEdited"
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={20}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(
  connect(state => ({
    jobsData: state.jobCardState,
  }))(ViewJobCards)
);
